"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _flex = _interopRequireDefault(require("../../styles-common/flex"));

var _inputInfo = _interopRequireDefault(require("../../styles-common/input-info"));

var _formLabel = _interopRequireDefault(require("../../styles-common/form-label"));

var _inputGroup = _interopRequireDefault(require("../../styles-common/input-group"));

var _input = _interopRequireDefault(require("../../styles-common/input"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _creatable = _interopRequireDefault(require("react-select/creatable"));

var _style = require("./style");

var _valueFormats = _interopRequireDefault(require("@widget-editor/shared/lib/constants/value-formats"));

var _aggregations = _interopRequireDefault(require("@widget-editor/shared/lib/constants/aggregations"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var WidgetInfo =
/*#__PURE__*/
function (_react$default$Compon) {
  _inherits(WidgetInfo, _react$default$Compon);

  function WidgetInfo(props) {
    var _this;

    _classCallCheck(this, WidgetInfo);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WidgetInfo).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleUpdate", (0, _debounce["default"])(function () {
      var _this$props = _this.props,
          configuration = _this$props.configuration,
          patchConfiguration = _this$props.patchConfiguration;
      var _this$state = _this.state,
          title = _this$state.title,
          description = _this$state.description,
          caption = _this$state.caption,
          yAxisTitle = _this$state.yAxisTitle,
          xAxisTitle = _this$state.xAxisTitle,
          aggregateFunction = _this$state.aggregateFunction,
          format = _this$state.format;
      patchConfiguration({
        title: title,
        description: description,
        caption: caption,
        format: (format === null || format === void 0 ? void 0 : format.value) || "s",
        yAxisTitle: yAxisTitle,
        xAxisTitle: xAxisTitle,
        aggregateFunction: aggregateFunction,
        category: _objectSpread({}, configuration.category),
        value: _objectSpread({}, configuration.value, {
          format: (format === null || format === void 0 ? void 0 : format.value) || "s"
        })
      });
    }, 1000));

    _this.state = _this.stateFromProps(props.configuration);
    _this.setValueFormat = _this.setValueFormat.bind(_assertThisInitialized(_this));
    _this.setAggregation = _this.setAggregation.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(WidgetInfo, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevConfiguration = prevProps.configuration;
      var configuration = this.props.configuration;

      if (!(0, _isEqual["default"])(this.stateFromProps(prevConfiguration), this.stateFromProps(configuration))) {
        this.setState(this.stateFromProps(configuration));
      }
    }
  }, {
    key: "stateFromProps",
    value: function stateFromProps(configuration) {
      return {
        title: (configuration === null || configuration === void 0 ? void 0 : configuration.title) ? configuration.title : "",
        description: (configuration === null || configuration === void 0 ? void 0 : configuration.description) ? configuration.description : "",
        caption: (configuration === null || configuration === void 0 ? void 0 : configuration.caption) ? configuration.caption : "",
        xAxisTitle: (configuration === null || configuration === void 0 ? void 0 : configuration.xAxisTitle) ? configuration.xAxisTitle : "",
        yAxisTitle: (configuration === null || configuration === void 0 ? void 0 : configuration.yAxisTitle) ? configuration.yAxisTitle : "",
        aggregateFunction: (configuration === null || configuration === void 0 ? void 0 : configuration.aggregateFunction) ? configuration.aggregateFunction.toUpperCase() : null,
        format: this.resolveFormat(configuration)
      };
    }
  }, {
    key: "resolveFormat",
    value: function resolveFormat(configuration) {
      var _configuration$value;

      var format = (configuration === null || configuration === void 0 ? void 0 : (_configuration$value = configuration.value) === null || _configuration$value === void 0 ? void 0 : _configuration$value.format) || "s";

      var selectedFormat = _valueFormats["default"].find(function (f) {
        return f.value === format;
      });

      if (!selectedFormat && format && format !== "s") {
        return {
          label: format,
          value: format
        };
      }

      return selectedFormat;
    }
  }, {
    key: "setTitle",
    value: function setTitle(title) {
      this.setState({
        title: title
      });
      this.handleUpdate();
    }
  }, {
    key: "setDescription",
    value: function setDescription(description) {
      this.setState({
        description: description
      });
      this.handleUpdate();
    }
  }, {
    key: "setCaption",
    value: function setCaption(caption) {
      this.setState({
        caption: caption
      });
      this.handleUpdate();
    }
  }, {
    key: "setYAxis",
    value: function setYAxis(yAxisTitle) {
      this.setState({
        yAxisTitle: yAxisTitle
      });
      this.handleUpdate();
    }
  }, {
    key: "setXAxis",
    value: function setXAxis(xAxisTitle) {
      this.setState({
        xAxisTitle: xAxisTitle
      });
      this.handleUpdate();
    }
  }, {
    key: "setValueFormat",
    value: function setValueFormat(format) {
      this.setState({
        format: format
      });
      this.handleUpdate();
    }
  }, {
    key: "setAggregation",
    value: function setAggregation(agg) {
      this.setState({
        aggregateFunction: agg.value
      });
      this.handleUpdate();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state2 = this.state,
          title = _this$state2.title,
          description = _this$state2.description,
          caption = _this$state2.caption,
          yAxisTitle = _this$state2.yAxisTitle,
          xAxisTitle = _this$state2.xAxisTitle,
          aggregateFunction = _this$state2.aggregateFunction,
          format = _this$state2.format;
      var _this$props2 = this.props,
          isMap = _this$props2.isMap,
          advanced = _this$props2.advanced;
      return _react["default"].createElement(_flex["default"], null, _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-title"
      }, "Title"), _react["default"].createElement(_input["default"], {
        type: "text",
        placeholder: "Add title",
        name: "options-title",
        value: title,
        onChange: function onChange(e) {
          return _this2.setTitle(e.target.value);
        }
      })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-description"
      }, "Description"), _react["default"].createElement(_input["default"], {
        type: "text",
        placeholder: "Add description",
        name: "options-decription",
        value: description,
        onChange: function onChange(e) {
          return _this2.setDescription(e.target.value);
        }
      })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-caption"
      }, "Caption"), _react["default"].createElement(_input["default"], {
        type: "text",
        placeholder: "Add caption",
        name: "options-capton",
        value: caption,
        onChange: function onChange(e) {
          return _this2.setCaption(e.target.value);
        }
      })), !isMap && !advanced && _react["default"].createElement(_flex["default"], {
        row: true
      }, _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-y-axis"
      }, "Value"), _react["default"].createElement(_input["default"], {
        type: "text",
        placeholder: "Overwrite value axis name",
        name: "options-y-axis",
        value: yAxisTitle,
        onChange: function onChange(e) {
          return _this2.setYAxis(e.target.value);
        }
      })), _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-x-axis"
      }, "Category"), _react["default"].createElement(_input["default"], {
        type: "text",
        placeholder: "Overwrite category axis name",
        name: "options-x-axis",
        value: xAxisTitle,
        onChange: function onChange(e) {
          return _this2.setXAxis(e.target.value);
        }
      }))), !isMap && !advanced && _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-title"
      }, "Value aggregation"), _react["default"].createElement(_reactSelect["default"], {
        value: _aggregations["default"].find(function (agg) {
          return agg.value === aggregateFunction;
        }),
        onChange: this.setAggregation,
        options: _aggregations["default"],
        styles: _style.InputStyles
      })), !isMap && !advanced && _react["default"].createElement(_inputGroup["default"], null, _react["default"].createElement(_formLabel["default"], {
        htmlFor: "options-title"
      }, "Value format"), _react["default"].createElement(_creatable["default"], {
        isClearable: true,
        value: format,
        onChange: this.setValueFormat,
        options: _valueFormats["default"],
        styles: _style.InputStyles
      }), _react["default"].createElement(_inputInfo["default"], null, "We are using d3-format for formating values, you can input your own format or select a predefined one from the list. Read more about formats:", " ", _react["default"].createElement("a", {
        href: "https://github.com/d3/d3-format",
        target: "__BLANK"
      }, "here"), ".")));
    }
  }]);

  return WidgetInfo;
}(_react["default"].Component);

var _default = WidgetInfo;
exports["default"] = _default;